import React, { useState, useEffect, useRef } from "react";
import Select, { components } from "react-select";
import DropDownIcon from "../../assets/img/MenuDropdown.svg";
import SearchIcon from "../../assets/img/CountrySearch.svg";
import ModalWrapperV2 from "./modal-wrapper-v2";
import Helpers from "../../helpers/shared.helper";
import Translation from "../../services/translation.service";

const CountryMenuContainer = (props) => {
    const containerRef = useRef(null);
    const [hasScrollbar, setHasScrollbar] = useState(false);

    const checkForScrollbar = () => {
        if (containerRef.current) {
        const childContainer = containerRef.current.querySelector('.react-select__menu-list');
        if (childContainer) {
            if(!Helpers.isSmallDevice()) {
                const hasScroll = childContainer.scrollHeight > childContainer.clientHeight;
                setHasScrollbar(hasScroll);
            } else {
                setHasScrollbar(false);    
            }
        }
        }
    };

    useEffect(() => {
        checkForScrollbar();
        window.addEventListener('resize', checkForScrollbar);

        return () => {
        window.removeEventListener('resize', checkForScrollbar);
        };
    }, [props.children]); // Dependency array includes children

    return (
        <components.Menu {...props}>
        <div ref={containerRef} className={hasScrollbar ? "react-select-custom-country-option-container hasScrollbar" : "react-select-custom-country-option-container hasNoScrollbar"}>
            {props.children}
        </div>
        </components.Menu>
    );
};

const countriesData = Helpers.convertCountriesListBasedOn();
const countriesList = Object.values(countriesData).map(country => ({
    value: country.name,
    flagCode: country.iso_2code,
    countryCode: country.dial_code,
    iso_3code: country.iso_3code,
    label: (
        <div className="country-option-label">
            <img src="" alt={country.iso_2code} /> {/* Placeholder for flag */}
            <div>{country.name}</div>
        </div>
    )
}));

const CountrySelectModal = ({ defaultCountry, updateFieled, disabled, countrytoSkip, form_id, isCustom  }) => {
    const [selectedCountry, setSelectedCountry] = useState(defaultCountry);
    const [openCountryModal, setOpenCountryModal] = useState(false);

    const getFlag = (code) => {
        try {
            return require(`../../assets/img/flagsRounded/country_${code.toLowerCase()}.webp`);
        } catch {
            return "";
        }
    };

    const selectCountry = (event) => {
        setSelectedCountry(event.flagCode);
        setOpenCountryModal(false);

        // Follow CountrySelectBasic approach when isCustom is true
        if (isCustom) {
            if (form_id === "country_contact_user") {
                let iso = countriesData[event.flagCode].dial_code;
                updateFieled(event.flagCode, iso);
            } else {
                updateFieled(event, "form", "select");
            }
        } else {
            // Default behavior for non-custom usage
            updateFieled(event.flagCode, event.countryCode);
        }
    };

    const toggleCountryModal = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setOpenCountryModal(prev => !prev);
    };

    const CountryOption = (props) => (
        <components.Option {...props}>
            <div className="react-select-custom-country-option">
                <div>
                    <img src={getFlag(props.data.flagCode)} alt="" />
                    {Translation.keys[`country_${props.data.iso_3code}`] || props.data.value}
                </div>
                <span>({props.data.countryCode})</span>
            </div>
        </components.Option>
    );

    // const CountryMenuContainer = (props) => (
    //     <components.Menu {...props}>
    //         <div className="react-select-custom-country-option-container">
    //             {props.children}
    //         </div>
    //     </components.Menu>
    // );

    const CountryControl = ({ children, ...props }) => (
        <components.Control {...props}>
            <div className="react-select-custom-country-input">
                <img src={SearchIcon} alt="" />
                {children}
            </div>
        </components.Control>
    );

    // Update countriesList with actual flags
    const updatedCountriesList = countriesList
    .filter(country => !countrytoSkip || country.flagCode !== countrytoSkip)
    .map(country => ({
        ...country,
        label: (
            <div className="country-option-label">
                <img src={getFlag(country.flagCode)} alt={country.flagCode} />
                <div>{country.value}</div>
            </div>
        )
    }));

    const customNoOptionsMessage = () => (
        <div>&nbsp;</div>
    );

    return (
        <>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                    cursor: disabled ? "unset" : "pointer"
                }}
                onClick={!disabled ? toggleCountryModal : undefined}
            >
                {selectedCountry && (
                    <>
                        <div className="storefront-country-selected">
                            <img src={getFlag(selectedCountry)} alt="" />
                            {countriesData[selectedCountry]?.dial_code}
                        </div>
                        {!disabled && <img src={DropDownIcon} alt="" style={{ margin: "0px 8px" }} />}
                    </>
                )}
            </div>
            {openCountryModal && (
                <ModalWrapperV2 handleToggleModal={toggleCountryModal} heading={"stm_eligibility_select_country"} closeBtn="stf_eligibility_modal_close">
                    <div className="search-country-select">
                        <Select
                            unstyled
                            autoFocus
                            noOptionsMessage={customNoOptionsMessage}
                            classNamePrefix="react-select"
                            controlShouldRenderValue={false}
                            hideSelectedOptions={false}
                            isClearable={false}
                            className="react-select-country-custom"
                            placeholder={Translation.keys["stf_country_search"] || "Search"}
                            isSearchable
                            options={updatedCountriesList}
                            components={{
                                Control: CountryControl,
                                Option: CountryOption,
                                Menu: CountryMenuContainer,
                                DropdownIndicator: () => null
                            }}
                            onChange={selectCountry}
                            defaultValue={updatedCountriesList.find(country => country.flagCode === selectedCountry)}
                            menuIsOpen
                        />
                    </div>
                </ModalWrapperV2>
            )}
        </>
    );
};

export default CountrySelectModal;
